module.exports = __webpack_public_path__ + "static/media/screenshot-01.ae40d2bf.jpg";